/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SequenceEventOutScope = typeof SequenceEventOutScope[keyof typeof SequenceEventOutScope];


export const SequenceEventOutScope = {
  enrollments: 'enrollments',
  tasks: 'tasks',
  all: 'all',
} as const;
